import { Link, type LinkProps } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { MouseEventHandler, ReactNode } from 'react';

type CardActionButtonProps = Omit<ButtonProps, 'asChild' | 'variant' | 'onClick'> & {
    to?: LinkProps['to'];
    state?: LinkProps['state'];
    replace?: LinkProps['replace'];
    trailingIcon?: ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
};

export default function CardActionButton({
    children,
    className,
    to,
    state,
    replace,
    trailingIcon = <ArrowRight className="size-4 shrink-0" />,
    onClick,
    ...buttonProps
}: CardActionButtonProps) {
    const content = (
        <>
            <span className="truncate">{children}</span>
            {trailingIcon}
        </>
    );

    if (to !== undefined) {
        return (
            <Button
                asChild
                variant="surface"
                className={cn('w-full justify-between', className)}
                {...buttonProps}
            >
                <Link to={to} state={state} replace={replace} onClick={onClick}>
                    {content}
                </Link>
            </Button>
        );
    }

    return (
        <Button
            variant="surface"
            className={cn('w-full justify-between', className)}
            onClick={onClick}
            {...buttonProps}
        >
            {content}
        </Button>
    );
}
